export enum ModeloVariavel {
	PRECIPITACAO = 'PRECIPITACAO',
	PRESSAO_NIVEL_MAR = 'PRESSAO_NIVEL_MAR',
	TEMPERATURA = 'TEMPERATURA',
	UMIDADE_AR = 'UMIDADE_AR',
	VENTO = 'VENTO',
	CAPE = 'CAPE',
	CINE = 'CINE',
	INDICE_K = 'INDICE_K',
	CONVERGENCIA_UMIDADE_850_HPA = 'CONVERGENCIA_UMIDADE_850_HPA',
	DIVERGENCIA_VENTO = 'DIVERGENCIA_VENTO',
	AGUA_PRECIPITAVEL = 'AGUA_PRECIPITAVEL',
	VORTICIDADE_RELATIVA = 'VORTICIDADE_RELATIVA',
	UMIDADE_SOLO = 'UMIDADE_SOLO',
	NEBULOSIDADE = 'NEBULOSIDADE',
	ALTURA_GEOPOTENCIAL = 'ALTURA_GEOPOTENCIAL',
	EVAPOTRANSPIRACAO_POTENCIAL = 'EVAPOTRANSPIRACAO_POTENCIAL',
	// RADIACAO_ONDA_LONGA = 'RADIACAO_ONDA_LONGA',
	// NEVOEIRO = 'NEVOEIRO',
}

export const getLabelModeloVariavel = (
	variavel: ModeloVariavel | string
): string => {
	switch (variavel) {
		case ModeloVariavel.PRECIPITACAO:
			return 'Precipitação (mm)';
		case ModeloVariavel.PRESSAO_NIVEL_MAR:
			return 'Pressão reduzida ao nível médio do mar (hPa)';
		case ModeloVariavel.TEMPERATURA:
			return 'Temperatura (ºC)';
		case ModeloVariavel.UMIDADE_AR:
			return 'Umidade relativa (%)';
		case ModeloVariavel.VENTO:
			return 'Vento (m/s)';
		case ModeloVariavel.CAPE:
			return 'CAPE (J kg-1)';
		case ModeloVariavel.CINE:
			return 'CINE (J kg-1)';
		case ModeloVariavel.INDICE_K:
			return 'Índice K';
		case ModeloVariavel.CONVERGENCIA_UMIDADE_850_HPA:
			return 'Convergência de umidade em 850 hPa (kg m^-2 s^-1)';
		case ModeloVariavel.DIVERGENCIA_VENTO:
			return 'Divergência do vento (10^-5 s^-1)';
		case ModeloVariavel.AGUA_PRECIPITAVEL:
			return 'Água precipitável (kg m-2)';
		case ModeloVariavel.VORTICIDADE_RELATIVA:
			return 'Vorticidade relativa (10-5 s-1)';
		case ModeloVariavel.UMIDADE_SOLO:
			return 'Umidade do solo (%)';
		case ModeloVariavel.NEBULOSIDADE:
			return 'Cobertura de núvens (%)';
		case ModeloVariavel.ALTURA_GEOPOTENCIAL:
			return 'Altura geopotencial (m)';
		case ModeloVariavel.EVAPOTRANSPIRACAO_POTENCIAL:
			return 'Evapotranspiração potencial (mm)';
		/*
    case ModeloVariavel.RADIACAO_ONDA_LONGA:
			return 'Radiação de onda longa (W m-2)';
		case ModeloVariavel.NEVOEIRO:
			return 'Nevoeiro (g/kg)';
    */
		default:
			return '';
	}
};
